<template>
  <router-view  />
  <previewImage></previewImage>
</template>
<script>
// import { createMetaInfo } from 'vue-meta-info'
import previewImage from '@/components/common/previewImage'
export default {
  // metaInfo: createMetaInfo(),
  name: 'App-',
  data () {
    return {
    }
  },
  components: {
    previewImage,
  },
}
</script>
<style lang="scss">
@import "@/assets/css/skinPeeler.scss";
@import "@/assets/css/public.scss";
@import "@/assets/css/quillFont.scss";
body {
  @include homeBg("bgStartColor", "bgEndColor", "bgImg");
  @include setColor("color","matrixBgcolor");
  // font-family: KaiTi;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
   width: 100%;
}
</style>
